import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';

import styled from 'styled-components';
import { FlexView, Row, Separator } from '@cuemath/comps';

import {
  getAll as getPaymentLinksList,
  invalidateList as invalidatePaymentsLinkList,
  patch as confirmPaymentStatus,
} from 'actions/student-payment-link';
import { get as getListCount } from 'actions/list-count';
import { openModal } from 'actions/modal';

import Pagination from 'modules/list/pagination';
import Search from 'modules/list/search-bar';

import { RESULTS_PER_PAGE } from 'constants/list';
import { RESOURCE_URL } from 'constants/api';
import PaymentLinkList from './list';

const FullFlexView = styled(FlexView)`
  width: 100%;
`;

const Head = styled(Row)`
  width: 100%;
  padding-left: 15px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

class PaymentsLinkTab extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      searchKey: null,
      listData: null,
      countData: null,
      paymentLinkData: null,
      paymentDetails: null,
      paymentPatch: store.patch(),
      updatePaymentStatus: false,
      filterParam: null,
    };
  }

  static getDerivedStateFromProps(
    { studentPaymentLink, listCount, actions },
    { page, searchKey, paymentPatch, updatePaymentStatus },
  ) {
    const listParams = { page, per_page: RESULTS_PER_PAGE };
    const countParams = { count: true };
    const newState = {};
    const newPaymentPatch = store.patch(studentPaymentLink, paymentPatch.id);

    if (newPaymentPatch.resolved && updatePaymentStatus) {
      if (newPaymentPatch.resolved.isPatched) {
        newState.paymentPatch = newPaymentPatch;
        newState.studentData = newPaymentPatch.resolved.data;
        actions.invalidatePaymentsLinkList();
      } else if (newPaymentPatch.resolved.isPatchingFailed) {
        newState.studentPatch = newPaymentPatch;
        alert(store.getError(newPaymentPatch.resolved).message);
      }
      newState.updatePaymentStatus = false;
    }

    newState.paymentLinkData = store.getAll(studentPaymentLink, listParams);
    newState.countData = store.get(
      listCount,
      RESOURCE_URL.studentPaymentLinks,
      countParams,
    );

    return newState;
  }

  componentDidMount() {
    const { actions } = this.props;
    const { page } = this.state;
    const filterData = { page, per_page: RESULTS_PER_PAGE };
    const listParams = { page, per_page: RESULTS_PER_PAGE };
    const countParams = { count: true };
    const countFilterParams = { count: true, page, per_page: RESULTS_PER_PAGE };
    actions.getListCount(
      RESOURCE_URL.studentPaymentLinks,
      countParams,
      countFilterParams,
    );

    actions.getPaymentLinksList(listParams, filterData);
  }

  componentDidUpdate(prevProps, prevState) {
    const { actions } = this.props;
    const { page, searchKey, paymentLinkData, filterParam } = this.state;
    const listParams = { page, per_page: RESULTS_PER_PAGE };
    const countParams = { count: true };
    const countFilterParams = { count: true, page, per_page: RESULTS_PER_PAGE };
    const searchData = { page, per_page: RESULTS_PER_PAGE };

    if (searchKey) {
      searchData.search = searchKey;
      countFilterParams.search = searchKey;
    }
    const isListStale = !!(paymentLinkData && paymentLinkData.isStale);

    if (
      prevState.searchKey !== searchKey ||
      filterParam !== prevState.filterParam ||
      prevState.page !== page ||
      isListStale
    ) {
      if (filterParam) {
        filterParam.forEach(filter => {
          let value = filter.value;
          const key = filter.id;

          if (value && Array.isArray(value) && value.length) {
            searchData[key] = value;
            countFilterParams[key] = value;
          } else {
            if (value !== null) {
              searchData[key] = value;
              countFilterParams[key] = value;
            }
          }
        });
      }
      actions.getPaymentLinksList(listParams, searchData);
      actions.getListCount(
        RESOURCE_URL.studentPaymentLinks,
        countParams,
        countFilterParams,
      );
    }
  }

  onPageChange = newPage => {
    this.setState({ page: newPage });
  };

  onSearch = searchKey => {
    if (searchKey !== this.state.searchKey && (this.state.searchKey || searchKey))
      this.setState({ searchKey: searchKey });
  };

  onFilter = filters => {
    this.setState({ filterParam: filters });
  };

  render() {
    const { page, searchKey, paymentLinkData, countData } = this.state;

    return (
      <FullFlexView justifyContent="center" alignItems="center">
        <Head>
          <Search onSearch={this.onSearch} placeholder="Search Students..." />
        </Head>
        <Separator transparent height="25" />
        <PaymentLinkList
          paymentLinkData={!!paymentLinkData ? paymentLinkData.data : []}
          page={page}
          searchKey={searchKey}
          onFilter={this.onFilter}
          count={!!countData ? countData.data : 0}
        />
        <Pagination
          page={page}
          perPage={RESULTS_PER_PAGE}
          onPageChange={this.onPageChange}
          count={!!countData ? countData.data : 0}
        />
      </FullFlexView>
    );
  }
}

export default connect(
  ({ studentPaymentLink, listCount }) => ({
    studentPaymentLink,
    listCount,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        invalidatePaymentsLinkList,
        getPaymentLinksList,
        openModal,
        confirmPaymentStatus,
        getListCount,
      },
      dispatch,
    ),
  }),
)(PaymentsLinkTab);
